var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"container-fluid"},[_c('h1',{staticClass:"main-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showWizard),expression:"showWizard"}]},[_c('downtime-reason-wizard',{attrs:{"parent-category-id":_vm.parentCategoryId,"initial-reason":_vm.reason}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }